const nonAlphaNumericRegex = /[^a-zA-Z0-9-]/g;
const repeatedSeparatorsRegex = /([-_]){2,}/g;
const trimSeparatorsRegex = /^[-_]+|[-_]+$/g;
const combiningMarksRegex = /[\u0300-\u036f]/g;

const removeDiacritics = (input: string): string => input.normalize('NFD').replace(combiningMarksRegex, '');

export const slugifyCode = (input: string): string => {
  const sanitized = removeDiacritics(input).toLowerCase();

  return sanitized
    .replace(nonAlphaNumericRegex, '-')
    .replace(repeatedSeparatorsRegex, '-')
    .replace(trimSeparatorsRegex, '');
};

export const normalizeCodeInput = (input: string): string => slugifyCode(input.trim());
